@if (userLogined && userName) {
  <header class="app-header">
    <div class="header-left">
      <button
        type="button"
        class="burger-btn"
        (click)="toggleSidebar()"
        [attr.aria-label]="sidebar.isOpen() ? 'Close menu' : 'Open menu'"
        [attr.aria-expanded]="sidebar.isOpen()">
        <i class="bi" [class.bi-x-lg]="sidebar.isOpen()" [class.bi-list]="!sidebar.isOpen()"></i>
      </button>
      <button
        *ngIf="canGoBack()"
        type="button"
        class="appbar-back-btn"
        (click)="goBack()"
        aria-label="Back">
        <i class="bi bi-arrow-left"></i>
      </button>
      <a [routerLink]="isAdmin && !isNative ? ['/admin'] : ['/dashboard']" class="app-header-title app-brand desktop-brand" [attr.aria-label]="brand.productName">
        <img
          class="app-brand-logo"
          [src]="brand.logoMark"
          [srcset]="brand.logoMarkSrcset"
          alt=""
          decoding="async" />
      </a>
    </div>
    <div class="app-header-actions">
      <a [routerLink]="isAdmin && !isNative ? ['/admin'] : ['/dashboard']" class="app-header-title app-brand mobile-brand" [attr.aria-label]="brand.productName">
        <img
          class="app-brand-logo"
          [src]="brand.logoMark"
          [srcset]="brand.logoMarkSrcset"
          alt=""
          decoding="async" />
      </a>
      @if (recentMilestones.length > 0) {
        <div class="header-badges" aria-label="Earned badges" data-testid="header-badges">
          @for (milestone of recentMilestones; track milestone.milestoneId || milestone.title) {
            <span
              class="header-badge"
              [attr.title]="milestone.title + (milestone.subjectName ? ' · ' + milestone.subjectName : '') + (milestone.xpAwarded ? ' · +' + milestone.xpAwarded + ' XP' : '')"
            >
              <i class="bi bi-award-fill" aria-hidden="true"></i>
              <span class="header-badge-label">{{ milestone.title }}</span>
            </span>
          }
        </div>
      }
      <a routerLink="/my-profile" class="header-link"><i class="bi bi-person"></i> {{ userName }}</a>
      <span class="header-sep">|</span>
      <a routerLink="/logout" class="header-link logout-link">Logout</a>
    </div>
  </header>
}
